/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/require-await */
import { useEffect, useCallback } from 'react';
import type { ProcessErrorArgs } from '@azure/service-bus';

import { createNotificationReceiver, sbClient } from 'services/ServiceBus';

import type { NotificationMessage, Props } from './types';

function useNotificationReceiver({
  messageHandler,
  errorHandler,
  receiverUserId
}: Props) {
  const processMessage = useCallback(
    async ({ body: notification }: NotificationMessage) => {
      messageHandler(notification);
    },
    [messageHandler]
  );

  const processError = useCallback(
    async (error: ProcessErrorArgs) => {
      if (errorHandler) errorHandler(error);
    },
    [errorHandler]
  );

  useEffect(() => {
    const receiver = createNotificationReceiver(receiverUserId);

    receiver.then((ServiceBusSessionReceiver) => {
      ServiceBusSessionReceiver.subscribe({
        processMessage,
        processError
      });
    });

    return () => {
      sbClient.close();
    };
  }, [processError, processMessage, receiverUserId]);
}

export default useNotificationReceiver;
